import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import ListHeader from '../components/list/ListHeader';
import TableUI from '../components/list/TableUI';
import FilterPannel from '../components/filter/FilterPannel';
import HeaderViewList from '../components/list/HeaderViewList';
import withRouter from '../util/WithRouter';
import Const from '../util/Constants';
import CustomerAPI from '../api/CustomerAPI';
import Util from '../util/Util';
import KeyValueAPI from '../api/KeyValueAPI';
import Display from '../util/Display';
import ImportExportAPI from '../api/ImportExportAPI';
import ViewController from '../controller/ViewController';
// import { logEvent } from 'firebase/analytics';
// import { analytics } from '../firebase';

class CustomerList extends React.Component {

  constructor(props) {
    super(props);

    const query = new URLSearchParams(props.location.search);
    const filters = query.get("filters") ? JSON.parse(query.get("filters")) : null;

    this.model = reactLocalStorage.getObject(Const.Model).customer;

    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    this.views = ViewController.getViews(Const.Customer);
    this.view = this.views.find((view) => view.id === (filters ? 0 : cView.customer ? cView.customer : 0));
    if (!this.view) {
      this.view = this.views.find(view => view.id === 0);
    }

    this.List = Util.isAllow(this.model.permission, Const.PermView);
    this.Add = Util.isAllow(this.model.permission, Const.PermAdd);
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);
    this.ListRestrict = Util.isAllow(this.model.permission, Const.PermListFieldRestrict);

    this.setList(filters);

    this.data = { customers: [], count: 0 };
    this.state = { massUpdate: false, massEmail: false, massSMS: false, inApiCall: true, isFilterOpen: false };

    this.selected = [];

    this.path = this.props.match.path;//.replace('customer', 'lead');
  }

  componentDidMount() {
    //  this.trackPageView();
    if (this.List) {
      this.loadCustomers();
    }
  }

  // componentDidUpdate(prevProps) {
  //   // If the path has changed, track the page view again
  //   if (this.props.location.pathname !== prevProps.location.pathname) {
  //     this.trackPageView();
  //   }
  // }
  // Track page view using Firebase Analytics
  // trackPageView() {
  //   const { location } = this.props;
  //   logEvent(analytics, 'page_view', {
  //     page_location: window.location.href,  
  //     page_path: location.pathname, 
  //     page_title: 'Customer Page',      
  //   });
  // }

  setList = filters => {
    let modelfields = reactLocalStorage.getObject(Const.FieldList);
    let lists = modelfields.customer;
    if (!lists) {
      lists = [];
      modelfields = { ...modelfields, customer: lists };
    }

    const fields = ["firstname", "enquiry_date", "phone", "email", "address~street", "address~city", "source",
      "responsible_person"];
    this.list = lists.find(list => list.view === this.view.id);

    if (!this.list) {
      this.list = { view: this.view.id };
      modelfields = { ...modelfields, customer: [...modelfields.customer, this.list] };
    }

    this.list.fields = this.list.fields ? this.list.fields : fields;
    this.list.filters = filters ? filters : this.list.filters ? this.list.filters : [];

    this.list.pagination = this.list.pagination ? this.list.pagination : {};
    this.list.pagination.currentPage = this.list.pagination.currentPage ? this.list.pagination.currentPage : 1;
    this.list.pagination.pageCount = this.list.pagination.pageCount ? this.list.pagination.currentPage : 1;
    this.list.pagination.perPage = this.list.pagination.perPage ? this.list.pagination.perPage : 10;

    this.list.sorting = this.list.sorting ? this.list.sorting : {};
    this.list.sorting.field = this.view.sortField ? this.view.sortField : 'enquiry_date';
    this.list.sorting.order = this.view.sortOrder ? this.view.sortOrder : -1;

    if (this.ListRestrict) {
      this.list.fields = this.view && this.view.fields && this.view.fields.length > 0 ? this.view.fields : fields;
    }

    this.list.fields = this.list.fields.filter((field) => {
      if (!field) {
        return false;
      }

      if (field.includes(Const.Opt))
        return (
          this.model.fields[field.split(Const.Opt)[0]] &&
          this.model.fields[field.split(Const.Opt)[0]].visible === Const.True
        );
      else
        return (
          this.model.fields[field] &&
          this.model.fields[field].visible === Const.True
        );
    });

    reactLocalStorage.setObject(Const.FieldList, modelfields);
  };

  saveListFilters = filters => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.lead.find((item) => item.view === this.view.id);
    tmp.filters = filters;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
  };

  saveListFields = fields => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.lead.find((item) => item.view === this.view.id);
    tmp.fields = fields;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, tmpField, () => { });
  };

  savePerPage = perPage => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.lead.find((item) => item.view === this.view.id);
    tmp.pagination.perPage = perPage;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, tmpField, () => { });
  };

  savePageChange = currentPage => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.lead.find((item) => item.view === this.view.id);
    tmp.pagination.currentPage = currentPage;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
  };

  loadCustomers = () => {
    const filters = ViewController.filters([...this.list.filters], this.view.filters, this.Restrict);
    this.setState({ ...this.state, inApiCall: true });
    CustomerAPI.list({ ...this.list, filters }, this.onReceived, this.onFail);
  };

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };

  onReceived = res => {
    this.data.customers = res.data;
    this.data.count = res.count;
    this.list.pagination.pageCount = Math.ceil(res.count / this.list.pagination.perPage);
    this.setState({ ...this.state, inApiCall: false });
  };

  onPageChange = currentPage => {
    this.list.pagination.currentPage = currentPage;
    this.savePageChange(currentPage);
    this.loadCustomers();
  };

  onPerPageChange = perPage => {
    this.list.pagination.perPage = perPage;
    this.savePerPage(perPage);
    this.loadCustomers();
  };

  onFieldSelection = fields => {
    if (fields.includes('phone') && this.HideAllPhone) {
      fields = fields.splice(this.list.fields.indexOf('phone'), 1);
    }
    this.list.fields = fields;
    this.saveListFields(fields);
    this.loadCustomers();
  };

  toggleFilter = () => {
    this.list.isFilterOpen = !this.state.isFilterOpen;
    this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen });
  };
  onFilterChange = filters => {
    this.list.pagination.currentPage = 1;
    this.list.filters = filters;
    this.savePageChange(this.list.pagination.currentPage);
    this.saveListFilters(filters);
    this.loadCustomers();
  };

  onAddEdit = indx => this.props.navigate(`${this.path}/add-edit/`
    + `${indx !== -1 ? this.data.customers[indx].id : 0}`);
  onPreview = indx => this.props.navigate(`${this.path}/preview/`
    + `${this.data.customers[indx].id}`);
  onDelete = indx => Util.confirmAlert('Delete', `Are you sure you want to delete to`
    + ` ${Display.ModelName(this.data.customers[indx])}`, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      CustomerAPI.delete(this.data.customers[indx].id, this.onDeleteSuccess, this.onFail);
    });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Customer deleted successfully', 'success');
    this.loadCustomers();
  };

  export = fields => Util.confirmAlert('Export', `Are you sure you want to export to with `
    + ` applied filters ? `, 'Export', 'Cancel', () => {
      this.setState({ ...this.state, inApiCall: true });
      ImportExportAPI.exportModel(Const.Customer, this.list.filters, this.data.count, fields,
        this.model.model_no, this.onExport, this.onFail);
    });
  onExport = () => {
    this.setState({ ...this.state, inApiCall: false });
    Util.showNotification('Successful', 'Customer Exported in progress.'
      + ' Please visit Settings', 'success');
  };

  onTabClick = (view) => {
    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    cView.lead = view;
    reactLocalStorage.setObject(Const.CurrentViews, cView);
    if (this.view.id !== view) {
      this.view = this.views.find((item) => item.id === view);
      this.setList();
      this.loadCustomers();
    }
    this.setState({ ...this.state, isFilterOpen: false });
  };

  render() {
    if (!this.List) return null;
    return (
      <div>

        <HeaderViewList
          views={this.views}
          view={this.view}
          onTabClick={this.onTabClick}
        />

        <ListHeader
          model={this.model}
          name={this.model.label_name}
          pagination={this.list.pagination}
          listCount={this.data.count}
          filterCount={this.list.filters.length}
          onPageChange={this.onPageChange}
          perPage={this.list.pagination.perPage}
          onPerPageChange={this.onPerPageChange}
          toggleFilter={this.toggleFilter}
          onAddClick={() => this.onAddEdit(-1)}
          add={this.Add}
          import={this.import}
          export={this.export}
        />

        <div className="container-fluid ">
          <div className="row">
            <TableUI
              data={this.data.customers}
              model={this.model}
              fields={this.list.fields}
              pagination={this.list.pagination}
              inApiCall={this.state.inApiCall}
              preview={true}
              update={this.Update}
              delete={this.Delete}
              onAddEdit={this.onAddEdit}
              onPreview={this.onPreview}
              onDelete={this.onDelete}
              onFieldSelection={this.onFieldSelection}
              isFilterOpen={this.state.isFilterOpen}
            />

            <FilterPannel
              filters={this.list.filters}
              fields={this.model.fields}
              onFilterChange={this.onFilterChange}
              isFilterOpen={this.state.isFilterOpen}
              restrict={this.Restrict}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(CustomerList);